import React from "react";
import { ShieldCheck, Check } from "lucide-react";

const GUARANTEES = [
  "Potrai lasciare il corso liberamente entro le 13",
  "Riceverai il rimborso completo tramite PayPal",
  "Potrai conservare i materiali come nostro omaggio",
];

export default function Garanzia() {
  return (
    <section className="py-24 lg:py-36">
      <div className="container-max">
        <div className="bg-card border border-white/10 rounded-3xl p-8 lg:p-16 relative overflow-hidden">
          <div className="absolute top-0 right-0 w-96 h-96 rounded-full bg-lime opacity-[0.04] blur-3xl -translate-y-1/2 translate-x-1/2" style={{ background: "#d4ff3d" }} />

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center relative">
            <div className="lg:col-span-5">
              <div className="inline-flex items-center gap-3 border border-white/10 rounded-full px-4 py-2 text-white/70 text-xs uppercase tracking-widest">
                <ShieldCheck size={14} className="text-lime" style={{ color: "#d4ff3d" }} /> Garanzia "Zero Rischi"
              </div>
              <h2 className="font-display text-4xl lg:text-6xl leading-[1] text-white mt-6">
                Nessuna pressione.<br />
                <span className="italic font-light text-white/60">Nessun rischio.</span>
              </h2>
              <p className="text-white/70 text-base lg:text-lg mt-8 leading-relaxed max-w-md">
                Partecipa alla sessione mattutina. Se non sarai soddisfatto, entro le 13:
              </p>
            </div>

            <div className="lg:col-span-7">
              <ul className="space-y-4">
                {GUARANTEES.map((g, i) => (
                  <li
                    key={i}
                    className="flex items-center gap-5 bg-[#0c0c0c] border border-white/10 rounded-2xl p-5 hover-lift"
                  >
                    <div className="w-11 h-11 rounded-full bg-lime flex items-center justify-center flex-shrink-0" style={{ background: "#d4ff3d" }}>
                      <Check size={18} className="text-black" />
                    </div>
                    <span className="text-white/90 text-base lg:text-lg">{g}</span>
                  </li>
                ))}
              </ul>

              <div className="mt-8 font-mono-label text-white/40 text-xs">
                → Solo la tua soddisfazione.
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
